import { textForUserOrAIEdited } from "constants/list"
import { canEditTask, isWithinLast24Hours } from "utils"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"

const todosTransformer = response => {
  const res = {
    ...response,
    deadlineCounters: {
      overdue: response?.deadlineCounters?.overdue,
      today: response?.deadlineCounters?.today,
      tomorrow: response?.deadlineCounters?.tomorrow,
      week: response?.deadlineCounters?.week,
      all: response?.deadlineCounters?.all,
    },
  }

  res.data = res.data?.map(item => ({
    ...item,
    canEdit: canEditTask(item) && item?.TaskPerformed?.ParentStatus?.key !== "sales",
    editedText: textForUserOrAIEdited()[item?.updatedBySource] || "",
    privileges: createPrivilegeObject(item?.privileges),
  }))

  return res
}

export default todosTransformer
